// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader___4c8U","loader-animation":"styles_loader-animation__X2q8_"};